import {
  NbPasswordAuthStrategyOptions,
  NbPasswordStrategyReset
} from '@nebular/auth';

export class PasswordAuthStrategyOptions extends NbPasswordAuthStrategyOptions {
  clientId?: string;
  clientSecret?: string;
  grantType: string;
  resetPass?: boolean | PasswordStrategyReset;
}

export const passwordStrategyOptions: PasswordAuthStrategyOptions =
  new PasswordAuthStrategyOptions();

interface PasswordStrategyReset extends NbPasswordStrategyReset {
  emailLinkReset?: string;
}
